import React from "react";

export const CampsHero = ({ c }) => (
  <section className="bg-[#0F1B2D] text-white pt-28 sm:pt-36 pb-16 sm:pb-24 relative grain">
    <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
      <div className="overline text-[#C4A46A]">{c.kicker}</div>
      <div className="mt-8 flex items-center gap-6 sm:gap-8">
        <div className="flex items-center gap-4 sm:gap-5">
          <img src="/nc-logo.png" alt="Northcrest Athletics" className="h-16 sm:h-20 w-auto opacity-95" />
          <div className="leading-[1.05]">
            <div className="font-display text-white text-base sm:text-lg tracking-[0.32em]">NORTHCREST</div>
            <div className="font-display text-[#C4A46A] text-[11px] sm:text-xs tracking-[0.5em]">ATHLETICS</div>
          </div>
        </div>
        <span className="font-display text-[#C4A46A] text-2xl sm:text-3xl">×</span>
        <img src="/partners/sporting-cp.png" alt="Sporting Clube de Portugal" className="h-16 sm:h-20 w-auto" loading="lazy" />
      </div>
      <h1 className="mt-8 font-display text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.05]">
        {c.title}
      </h1>
      <span className="gold-rule mt-8 block" />
      <p className="mt-10 max-w-3xl text-white/80 text-lg leading-relaxed">{c.intro}</p>
    </div>
  </section>
);
